
import React from 'react';

import { utils } from '../../core';

import ParameterListWithGeom from './ParameterListWithGeom';

const SearchFormParams = ({
    generatePolygonDefinition,
    paramValues,
    searchDefinition,
    tempFeature,
    onDoSearch,
    onChangeValid,
    onSetGeometry,
    onSetIsGeoActive,
    onSetParamValue
}) => {

    const doChangeValid = (valid) => {
        if (onChangeValid) {
            onChangeValid(valid);
        }
    }

    const handleSearch = () => {
        if (onDoSearch) {
            onDoSearch(searchDefinition.id);
        }
    }

    const getParams = () => {
        return (searchDefinition)
            ? searchDefinition.params
            : [];
    }

    const handleChangeParamValue = (paramId, value) => {
        onSetParamValue(paramId, value);
        // ToDo:
        doChangeValid(true);
    }

    return (
        <ParameterListWithGeom
            generatePolygonDefinition={generatePolygonDefinition}
            onChangeValue={handleChangeParamValue}
            onConfirm={handleSearch}
            onSetGeometry={onSetGeometry}
            onSetIsGeoActive={onSetIsGeoActive}
            options={utils.styles.SELECT_ATTR_VALUE_STYLES_OPTIONS}
            params={getParams()}
            paramValues={paramValues}
            tempFeature={tempFeature}
        />
    );
}

export default SearchFormParams;
